/**
 * @async
 * @type {function} putData
 * @param {string} apiKey - api key for OdinPay
 * @param {string} url - target URL
 * @param {object} data - data to put
 * @return {Promise<paymentMethodPutResponse>}
 */
async function putData(apiKey, url = "", data = {}) {
	const headers = new Headers();
	headers.append("Authorization", apiKey);

	const response = await fetch(url, {
		method: "PUT",
		headers,
		referrerPolicy: "strict-origin-when-cross-origin",
		body: JSON.stringify(data)
	});
	if (!response.ok) {
		let res = await response.json();
		// if there is no statusCode, its a unique "unauthorized" error that needs to have the code added from the response
		if (!res.statusCode) {
			res = {
				...res,
				statusCode: response.status
			};
		}
		throw res;
	}
	return response.json();
}

export const Api = (baseUrl, apiKey) => {
	// eslint-disable-next-line no-underscore-dangle
	const _baseUrl = baseUrl;
	// eslint-disable-next-line no-underscore-dangle
	const _apiKey = apiKey;
	return {
		/**
		 * @async
		 * @type {function} putPaymentMethod
		 * @param {paymentMethodPutPayload} payload
		 * @return {Promise<paymentMethodPutResponse>}
		 */
		putPaymentMethod: async (payload) => {
			return putData(_apiKey, `${_baseUrl}/payment-methods`, {
				...payload
			});
		}
	};
};

/**
 * @template T
 * @param {Promise<T>} promise
 * @returns {Promise<[T, null] | [null, OdinError]>}
 */
export const safeTry = async (promise) => {
	try {
		const result = await promise;
		return [result, null];
	} catch (error) {
		return [null, error];
	}
};
